import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {BranchSelectors} from '@store/branches/branch.selectors';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {CatalogRecordAvailability} from '@store/catalog/catalog.types';
import {MatIcon} from '@angular/material/icon';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {NgClass, NgTemplateOutlet} from '@angular/common';

@Component({
  selector: 'px-catalog-home-branch-availability',
  templateUrl: './catalog-home-branch-availability.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, MatIcon, NgClass, NgTemplateOutlet]
})
export class CatalogHomeBranchAvailabilityComponent {
  public readonly availabilitySelectors = CatalogSelectors.Availability;
  public readonly authBranchSelectors = BranchSelectors.Auth;
  public readonly patronSelectors = PatronSelectors.Auth;

  @Input({required: true}) public availability: CatalogRecordAvailability;
  @Input() forTableColumn: boolean;
}
